// make these match up with _colors.scss
export const GRAY_950 = '#111111'
export const GRAY_800 = '#232529'
export const GRAY_700 = '#3C3941'
export const GRAY_600 = '#626468'
export const GRAY_500 = '#77787A'
export const GRAY_450 = '#999999'
export const GRAY_400 = '#ADAEAF'
export const GRAY_300 = '#D1D2D3'
export const GRAY_100 = '#F4F4F4'
export const PURPLE_800 = '#2C2933'
export const PRIMARY_200 = '#D6F5F3'
export const WHITE = '#FFFFFF'
export const BLACK = '#000000'
export const YELLOW_400 = '#FFC802'
export const RED_300 = '#FF877A'
export const BLUE_200 = '#1E90FF'
export const BLUE_100 = '#78ACAC'
export const GREEN_300 = '#50EF73'
